import Service from './baseService';

export const getVehicleAssigmentSeatMappings = (vehicleAssignmentID) => {
    return Service.get(`/seatMappings/${vehicleAssignmentID}`);
};
